<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { use, graphic } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

// import { getHeatingPowerHourly } from "@/api/api.js";

export default {
  components: {},
  props: ["data"],
  data() {
    return {
      option: {
        color: ["#dba900", "#02dbc3"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },

        grid: {
          top: "10%",
          left: "3%",
          right: "2%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [
              "00:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",
            ],
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#557562",
              },
            },
            axisLabel: {
              show: true,
              color: "#a3fffe",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              lineStyle: {
                color: "#114556",
              },
            },

            axisLabel: {
              show: true,
              color: "#a3fffe",
              fontSize: 16,
            },
          },
        ],
        series: [
          {
            name: "人数",
            type: "line",
            emphasis: {
              focus: "series",
            },
            data: Array.from({ length: 10 }, () => 
                this.random_number(0, 20)
            ).concat(Array.from({ length: 14 }, () => 
                this.random_number(30, 500)
            )),
            areaStyle: {
              opacity: 0.8,
              color: new graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(157, 227, 246, 0.9)",
                },
                {
                  offset: 1,
                  color: "rgba(100, 161, 245, 0.8)",
                },
              ]),
            },
            lineStyle: {
              color: "#264e53",
              width: 0.5,
            },
            itemStyle: {
              normal: {
                label: {
                  show: true
                }
              },
              opacity: 0,
            },
          },
        ],
      },
    };
  },
  methods: {
    getData() {
      // getHeatingPowerHourly().then((res) => {
      //   let result = res.data.data.map((item) => {
      //     return {name: item.data_time, num: item.head_count.data_total_num}
      //   });
      //   this.option.series[0].data = result.map((o) => { return o.num });
      //   this.option.xAxis[0].data = result.map((o) => {
      //     return o.name
      //   });
      // });
    }
  },
  mounted() {
    this.getData()
    this.timer = setInterval(this.getData, 60000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
};
</script>

<style scoped>
.chart {
  min-height: 250px;
}
</style>
